import React from 'react';
import Rating from 'react-rating';
import * as PropTypes from 'prop-types';
import { convertRating } from 'components/video-player/rate-video/video-rating';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStartRegular } from '@fortawesome/pro-regular-svg-icons';

export const VideoItemRating = ({ averageRating }) => {
  const fullSymbol = <FontAwesomeIcon icon={faStar}></FontAwesomeIcon>;
  const emptySymbol = <FontAwesomeIcon icon={faStartRegular}></FontAwesomeIcon>;

  const averageRate = convertRating(averageRating);

  let showHowManyStarsClass =
    averageRate <= 0 ? ' ct-rating--show-' + 1 : ' ct-rating--show-' + Math.round(averageRate);

  return (
    <div data-e2e="video-list-rating" className={`ct-rating ct-rating--display-small${showHowManyStarsClass}`}>
      <Rating
        start={0}
        stop={5}
        step={1}
        initialRating={convertRating(averageRating)}
        emptySymbol={emptySymbol}
        fullSymbol={fullSymbol}
        readonly={true}
      />
    </div>
  );
};

VideoItemRating.propTypes = {
  averageRating: PropTypes.number,
};
